import { useQuery } from '@tanstack/react-query';
import { searchContacts } from '../api/contacts';

export function useSearchContacts(q: string) {
  return useQuery({
    queryKey: ['contactSearch', q],
    queryFn: () => searchContacts(q),
    enabled: q.trim().length >= 1,
    staleTime: 10_000,
  });
}
